import {ToolBarStandardButton, ToolBarStandardButtonType} from "../../core/components/toolBar";
import {Config} from "../../core/config/config";
import {DialogHelper} from "../../core/util/dialogHelper";
import {General} from "../../../siteManagement/general";
import {SheetEventType} from "../../../siteManagement/sheet";
import {Helper} from "../../core/util/helper";
import {Grid} from "../../core/components/grid";
import {
    EditWorkPackageCapacityRequirement,
    EditWorkPackageCapacityRequirementProps
} from "./editWorkPackageCapacityRequirement";
import {WorkPackageEntity} from "./workPackage";
import { Entity } from "../../core/components/commonApp";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";

export default class WorkPackageCapacityRequimentsGridApp extends React.Component<WorkPackageCapacityRequirementsGridProps,WorkPackageRequirementsGridState>{
    private _gridData = [];
    private _gridOptions = {};
    private _enabled: boolean;
    ressTypeDs=[];
    constructor(props: WorkPackageCapacityRequirementsGridProps | Readonly<WorkPackageCapacityRequirementsGridProps>) {
        super(props); 
        this._enabled = !props.disabled;
        this._gridData = props.entity.CapacityRequirements;
        
        this._gridOptions = this.props.context.workPackageCapacityRequirementGridOptions;
        
        this.ressTypeDs = [{ text: Helper.getTranslation("Ressource.Ressource"), value: false }, { text: Helper.getTranslation("Field.Einsatz.grnr"), value: true }];
    }

    private _edit = (dataItem: any) => {
        this._openPos(dataItem).then(() => {});
    }

    private _openPos = async (dataItem: WorkPackageRequirementGridEntity = null) => {
        let result = await Helper.getMetaData("editWorkpackageCapacityRequirement");
        this._initCodeWindow(dataItem, result);
    }
    private _initCodeWindow = (entity: WorkPackageRequirementGridEntity, metaData: any) => {
        const entityCopy = JSON.parse(JSON.stringify(entity));
        const workPackageRequirementProps: EditWorkPackageCapacityRequirementProps = {
            disabled: this._enabled,
            entity: entityCopy,
            metadata: metaData,
            context: { key1: "entity.Id", keyVal1: entityCopy.Id, contextType: "editWorkpackageCapacityRequirement" },
            dataSources: {ressTypeDs: this.ressTypeDs},
            isWindow: true,
            title: Helper.getTranslation("WebCRM.Tasks.WorkPackage.RequiredCapacities")
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.SavedSuccessfully,
            (requirement: WorkPackageRequirementGridEntity) => {
                let item = Helper.getArrayItem(this.props.entity.CapacityRequirements, "Id", requirement.Id);
                if (item == null) {
                    item = JSON.parse(JSON.stringify(requirement));
                    this.props.entity.CapacityRequirements.push(item);
                } else {
                    item.Count = requirement.Count;
                    item.Hours = requirement.Hours;
                    item.IsGroup = requirement.IsGroup;
                    item.PlanningBoardFlagId = requirement.PlanningBoardFlagId;
                    item.PlanningBoardFlagName = requirement.PlanningBoardFlagName;
                    item.StartMinutes = requirement.StartMinutes;
                    item.IndividualFields = requirement.IndividualFields;
                    if (item.StartMinutes != null && item.StartMinutes > 0)
                        item.StartMinutesString = Helper.dates.fromMinutesSinceMidnight(item.StartMinutes);
                    if (!requirement.IsGroup) {
                        item.ResNo = requirement.ResNo;
                        item.Vorname = requirement.Vorname;
                        item.Name = requirement.Name;
                        item.GrNr=null;
                        item.Bezeichnung = '';
                    } else if (requirement.IsGroup) {
                        item.Bezeichnung = requirement.Bezeichnung;
                        item.GrNr = requirement.GrNr;
                        item.ResNo=''; 
                        item.Vorname = '';
                        item.Name ='';
                    }
                    
                }

                this.props.onChange(this.props.field, item.Id);
            });

        sheet.show(() => {
            sheet.mountContent(EditWorkPackageCapacityRequirement, workPackageRequirementProps);
        });
    }
    private _deletePos = async (id: string) => {

        let isOk = await DialogHelper.choose(Helper.getTranslation("WebCRM.Tasks.WorkPackage.Msg.DeleteReferences"),
            [{ label: Helper.getTranslation("Server.No"), value: 1 }, { label: Helper.getTranslation("Server.Yes"), value: 0 }], true);
        if (Helper.hasValue(isOk)) {
            let index = Helper.findObjIndex(this.props.entity.CapacityRequirements, "Id", id);
            if (index >= 0) {
                var item = this.props.entity.CapacityRequirements[index];
                this.props.entity.CapacityRequirements.splice(index, 1);
                this.props.onChange(this.props.field, id);
                if (isOk == 1) {
                    this._deleteReferences(item.Id);
                } else {
                    this._deleteReferencedEntries(item.Id);
                }
            }
        }
    }

    private _deleteReferences = (capacityRequirementId: string) => {
        //Referenzen von PartRequirements
        var partRequirements = this.props.entity.PartRequirements.filter(x => x.CapacityRequirementId == capacityRequirementId); 
        partRequirements.forEach(item => {
            item.CapacityRequirement = null;
            item.CapacityRequirementId = null;
            var index = this.props.entity.PartRequirements.findIndex(x => x.Id == item.Id);
            this.props.entity.PartRequirements[index] = item;
            this.props.onChange(this.props.field, item);
        });

        //Referenzen von TemplateRequirements
        var templateRequirements = this.props.entity.TemplateRequirements.filter(x => x.CapacityRequirementId == capacityRequirementId);
        templateRequirements.forEach(item => {
            item.CapacityRequirement = null;
            item.CapacityRequirementId = null;
            var index = this.props.entity.TemplateRequirements.findIndex(x => x.Id == item.Id);
            this.props.entity.TemplateRequirements[index] = item;
            this.props.onChange(this.props.field, item);
        });

    }

    private _deleteReferencedEntries = (capacityRequirementId: string) => {
        //Einträge von PartRequirements
        var partRequirements = this.props.entity.PartRequirements.filter(x => x.CapacityRequirementId == capacityRequirementId);
        partRequirements.forEach(item => {
            var index = this.props.entity.PartRequirements.findIndex(x => x.Id == item.Id);
            this.props.entity.PartRequirements.splice(index, 1);
            this.props.onChange(this.props.field, item);
        });

        //Einträge von TemplateRequirements
        var templateRequirements = this.props.entity.TemplateRequirements.filter(x => x.CapacityRequirementId == capacityRequirementId);
        templateRequirements.forEach(item => {
            var index = this.props.entity.TemplateRequirements.findIndex(x => x.Id == item.Id);
            this.props.entity.TemplateRequirements.splice(index, 1);
            this.props.onChange(this.props.field, item);
        });
    }

    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.NEW) {
            let entity: WorkPackageRequirementGridEntity = Helper.createEmptyEntity() as WorkPackageRequirementGridEntity;
            entity.Id = kendo.guid();
            entity.Count=1;
            entity.IsGroup = true;
            this._openPos(entity).then(() => {});
        } else if (type === ToolBarStandardButtonType.EDIT) {
            this._edit(dataItem);
        } else if (type == ToolBarStandardButtonType.DELETE) {
            this._deletePos(dataItem.Id).then(() => {});
        }
    }

    render() {
        const enableButtons = this._enabled;
        const enableEditButton = this._enabled;

        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: enableButtons });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: enableEditButton ? Config.translations.editLabel : Helper.getTranslation("WebCRM.Tasks.WorkPackage.Show"), enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: enableButtons });

        const content = <Grid data={this.props.entity.CapacityRequirements} options={this._gridOptions} id="workPackageCapacityRequirementsGrid"
            standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton} />

        return (content);
    }
}
interface WorkPackageRequirementsGridState {
    gridData: WorkPackageRequirementGridEntity[];
}
interface WorkPackageCapacityRequirementsGridProps{
    context: {
        workPackageCapacityRequirementGridOptions: {}
    },
    disabled: boolean;
    translations: StringKeyDictionary<string>;
    field: any;
    entity: WorkPackageEntity;
    onChange: (field, value) => void
}
export interface WorkPackageRequirementGridEntity extends Entity {
    Id: string;
    Count: number;
    Hours: number;
    GrNr?: number;
    ResNo: string;
    Name: string;
    Vorname: string;
    Bezeichnung: string;
    IsGroup: boolean;
    PlanningBoardFlagId?: string;
    PlanningBoardFlagName?: string;
    StartMinutes:number;
    StartMinutesString:string;
}